// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"repaymentCapacity_errorMessage__2sa2W","Title":"repaymentCapacity_Title__1QFKb"};